import { Box, IconButton, styled, TableCell, TableRow, TextField } from '@mui/material';
import { OrtPeriod } from '@types';
import { IconApproved, IconCancel } from 'assets/img';
import { DayHeaderCell } from './ort-table-day-header-cell';

type EditingRowProps = {
  isEditing: boolean;
  periodLength: number;
  dayLabel: string;
  tempPeriod: OrtPeriod;
  onStartTimeChange: (value: string) => void;
  onEndTimeChange: (value: string) => void;
  onSurchargeChange: (value: number) => void;
  onSave: () => void;
  onCancel: () => void;
};

export const EditingRow = ({
  isEditing,
  periodLength,
  dayLabel,
  tempPeriod,
  onStartTimeChange,
  onEndTimeChange,
  onSurchargeChange,
  onSave,
  onCancel,
}: EditingRowProps) => {
  if (!isEditing) {
    return null;
  }

  return (
    <TableRow data-testid="ort-period-edit-row">
      {periodLength === 0 && <DayHeaderCell label={dayLabel} rowSpan={2} />}
      <EditTableCell>
        <TextField
          name="startTime"
          type="time"
          value={tempPeriod.startTime}
          onChange={(e) => onStartTimeChange(e.target.value)}
          size="small"
          inputProps={{ 'data-testid': 'ort-period-edit-row-start-time-input' }}
        />
      </EditTableCell>
      <EditTableCell>
        <TextField
          name="endTime"
          type="time"
          value={tempPeriod.endTime}
          onChange={(e) => onEndTimeChange(e.target.value)}
          size="small"
          inputProps={{ 'data-testid': 'ort-period-edit-row-end-time-input' }}
        />
      </EditTableCell>
      <EditTableCell>
        <Box display="flex" gap={1} alignItems="center">
          <TextField
            type="number"
            value={tempPeriod.surcharge === 0 ? '' : tempPeriod.surcharge}
            onChange={(e) => {
              const value = e.target.value === '' ? 0 : Number(e.target.value);
              onSurchargeChange(value);
            }}
            placeholder="0"
            size="small"
            fullWidth
            inputProps={{ min: 0, 'data-testid': 'ort-period-edit-row-surcharge-input' }}
          />
        </Box>
      </EditTableCell>
      <StyledTableCell sx={{ textAlign: 'right' }}>
        <IconButton size="small" color="primary" onClick={onSave} data-testid="save-period-button">
          <IconApproved fontSize="small" />
        </IconButton>
        <IconButton size="small" color="error" onClick={onCancel}>
          <IconCancel fontSize="small" />
        </IconButton>
      </StyledTableCell>
    </TableRow>
  );
};

const EditTableCell = styled(TableCell)(({ theme }) => ({
  transition: 'box-shadow 0.2s, border-color 0.2s',
  backgroundColor: theme.palette.lwPrimaryAccentLight[10],
  position: 'relative',

  '&:has(.MuiInputBase-input:focus)': {
    border: `2px solid ${theme.palette.lwPrimaryAccentLight[100]}`,
  },

  '& .MuiInputBase-input': {
    padding: '4px 8px',
    height: 'auto',
    outline: 'none',
    border: 'none',
    width: 'auto',
  },
}));
const StyledTableCell = styled(TableCell)({
  fontWeight: 'bold',
  width: '20%',
});
